import { Component} from '@angular/core';

@Component({
  selector: 'app-tree',
  templateUrl: './tree.component.html',
  styles: [
  ]
})
export class TreeComponent  {



}
